import { ReactNode } from "react";
import { Box, Collapse, Divider, Flex, Group, Paper, Title, useMantineTheme } from "@mantine/core";
import { IconChevronDown, IconChevronRight } from "@tabler/icons-react";

export interface SectionProps {
    title?: string;
    isCollapsed?: boolean;
    actions?: ReactNode;
    children?: ReactNode;
    onClick?();
}

export const Section = ({ title, isCollapsed, actions, children, onClick }: SectionProps) => {
    const theme = useMantineTheme();

    return (
        <>
            <Flex>
                <Divider
                    style={{
                        flex: 1,
                        cursor: typeof onClick === "function" ? "pointer" : undefined,
                    }}
                    onClick={onClick}
                    label={
                        <Group spacing="sm" align="center">
                            {isCollapsed ? <IconChevronRight size={24} /> : <IconChevronDown size={24} />}
                            <Title mr="xs" order={3}>
                                {title}
                            </Title>
                        </Group>
                    }
                />
                {actions && <Box ml="sm">{actions}</Box>}
            </Flex>
            <Collapse in={!isCollapsed}>
                <Paper p="xl" radius="md" ml={`calc(24px + ${theme.spacing.sm})`} withBorder>
                    {children}
                </Paper>
            </Collapse>
        </>
    );
};
